import * as React from 'react';
import withStyles from 'react-jss';
import Navbar from 'src/common/Navbar/Navbar';
import { StylesProps } from 'src/theme/jss-types';
import { useTranslation } from 'react-i18next';

const styles = (theme: any): any => ({
  message: {
    textAlign: 'center',
    fontSize: '16px',
    width: '100%',
    marginTop: '20%',
  },
});

interface IProps extends StylesProps<ReturnType<typeof styles>> {
  title?: string;
}

const Unauthorized = (props: IProps) => {
  const { classes, title } = props;
  const { t } = useTranslation();

  return (
    <div>
      <Navbar title={title} />
      <div className={classes.message}>
        {t('You don’t have permission to view this page. Please contact admin for assistance')}
      </div>
    </div>
  );
};

export default withStyles(styles, { injectTheme: true })(Unauthorized);
